import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch((err) => {
    // Log bootstrap errors - using console.error is acceptable for critical bootstrap failures
    // as LoggingService is not available during bootstrap
    // NOSONAR - Console.error is required for bootstrap error logging
    if (typeof console !== 'undefined' && console.error) {
      console.error('Bootstrap error:', err);
    }
  });
